import { render } from "./MachinesComponent.vue?vue&type=template&id=5c71b5ef"
import script from "./MachinesComponent.vue?vue&type=script&lang=js"
export * from "./MachinesComponent.vue?vue&type=script&lang=js"

import "./MachinesComponent.vue?vue&type=style&index=0&id=5c71b5ef&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__